import React, { useState } from "react";
import Subtitle from "./typography/Subtitle";
import Title from "./typography/Title";
import Description from "./typography/Description";
import { ArrowUpRightIcon, UserIcon } from "@phosphor-icons/react/dist/ssr";
import Button from "../shared/button/Button";
import { heroSection } from "./Home/data";

const JoinUs = () => {
  const [email, setEmail] = useState("");

  const handlePost = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const date = new Date();
    const inputValue: { [key: string]: string } = {
      Email: email,
      "Created At": date.toLocaleString(),
    };

    // const APP_ID = process.env.REACT_APP_SHEETS_DEPLOYMENT_ID;
    const baseURL = process.env.REACT_APP_SHEETS_SCRIPT_URL;
    const formData = new FormData();
    Object.keys(inputValue).forEach((key) => {
      formData.append(key, inputValue[key]);
    });
    try {
      const res = await fetch(baseURL, {
        method: "POST",
        body: formData,
        redirect: "follow",
      });
      if (res.ok) {
        console.log("Request was successful:", res);
      } else {
        console.log("Request Failed:", res);
      }
    } catch (e) {
      console.error("Error during fetch:", e);
    }
  };
  return (
    <section
      id="joinUs"
      className="relative flex h-auto w-screen flex-col items-center justify-center gap-5 overflow-hidden bg-gray-950 py-5 md:min-h-[40vh]"
    >
      <div className="gradient-bg absolute left-0 top-2/3 h-1/2 w-full md:left-1/2 md:h-[65%] md:w-[65%] md:-translate-x-1/2" />
      <Subtitle>{heroSection.subtitle}</Subtitle>
      <Title>The Future of Recruiting Starts Here</Title>
      <Description>
        Be the first to access actionable reports, guides, tips, videos,
        podcasts from experts
      </Description>
      <form
        onSubmit={handlePost}
        className="flex w-full items-center justify-center"
      >
        <div className="relative z-10 flex h-12 w-full max-w-md items-center gap-2 rounded-lg border border-gray-700 bg-gray-800 py-1 pl-3 pr-2 focus-within:outline focus-within:outline-1 focus-within:outline-app-300">
          <UserIcon size={20} className="shrink-0" />
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Your Work Email"
            className="w-full grow appearance-none bg-transparent text-sm focus-visible:border-0 focus-visible:outline-none"
          />
          <Button
            disabled={email?.length < 5}
            type="submit"
            className="shrink-0 flex-row-reverse gap-2 px-2.5"
            icon={<ArrowUpRightIcon size={24} />}
            // onClick={handlePost}
          >
            Subscribe
          </Button>
        </div>
      </form>
    </section>
  );
};

export default JoinUs;
